import { render, staticRenderFns } from "./commonSubstituteCard.vue?vue&type=template&id=3499710d&scoped=true"
import script from "./commonSubstituteCard.vue?vue&type=script&lang=js"
export * from "./commonSubstituteCard.vue?vue&type=script&lang=js"
import style0 from "./commonSubstituteCard.vue?vue&type=style&index=0&id=3499710d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499710d",
  null
  
)

export default component.exports